export default "__VITE_ASSET__CjlPvcGy__"